import React, { useState, useEffect } from "react";
import { Bar } from 'react-chartjs-2'
import Chart from "chart.js/auto";
import { Cookies } from 'react-cookie';
import { API_SERVER } from "../../EnvConfig/env_config";
import { post } from "../Common/service";
import DatePicker from 'react-datepicker';
import { formatDate, ReverseFormatDate, setFocus } from "../Common/Common";

const cookies = new Cookies();

const Dashboard = ({ open, setOpen }) => {
    const [boardData, setBoardData] = useState([]);
    const currentDate = new Date(); // Get the current date
    const firstDayOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
    const formattedFromDate = formatDate(firstDayOfMonth);
    const formattedToDate = formatDate(currentDate);

    const [FilterData, setFilterData] = useState({
        DateFrom: formattedFromDate ? formattedFromDate:'',
        DateTo: formattedToDate ? formattedToDate:''
    });

    var ss = boardData.dailyChartDetails;
    var aa = boardData.dailyItemDetails;
    var vv = boardData.volumeValueDetails;
    var data = [];
    var data2 = [];
    var data3 = [];

    if (ss !== undefined && ss !== null) {
        for (let i = 0; i < ss.length; i++) {
            data.push({
                Customer: ss[i].customer,
                TotalValue: ss[i].totalValue
            });
        }
    };
    if (aa !== undefined && aa !== null) {
        for (let j = 0; j < aa.length; j++) {
            data2.push({
                Item: aa[j].item,
                TotalValue2: aa[j].totalValue
            });
        }
    };
    if (vv !== undefined && vv !== null) {
        for (let k = 0; k < vv.length; k++) {
            data3.push({
                SalesItem: vv[k].salesItem,
                SalesVolume: vv[k].salesVolume,
                SalesValue: vv[k].salesValue
            });
        }
    };
   

    const Customer = data.map((it) => it.Customer);
    const TotalValue = data.map((i) => i.TotalValue);
    const Item = data2.map((it) => it.Item);
    const TotalValue2 = data2.map((i) => i.TotalValue2);
    const SalesItem = data3.map((it) => it.SalesItem);
    const SalesVolume = data3.map((i) => i.SalesVolume);
    const SalesValue = data3.map((i) => i.SalesValue);

    const value = {
        labels: Customer,
        datasets: [
            {
                label: "Total Amount",
                backgroundColor: "rgb(0, 172, 230)",
                borderColor: "black",
                data: TotalValue,
            },

        ],
    };

    const value2 = {
        labels: Item,
        datasets: [
            {
                label: "Total Item",
                backgroundColor: "green",
                borderColor: "black",
                data: TotalValue2,
            },

        ],
    };

    const value3 = {
        labels: SalesItem,
        datasets: [
            {
                label: "Volume",
                backgroundColor: "rgb(6, 193, 10)",
                borderColor: "black",
                data: SalesVolume,
            },
            {
                label: "Value",
                backgroundColor: "red",
                borderColor: "black",
                data: SalesValue,
            }
        ],
    };
   
    const getChartAPI =  () => {
        let Token = cookies.get('token');
        let LoginUserCode = cookies.get('loginUserCode');

        if (!Token) {
            const cookies = new Cookies();
            cookies.remove('token');
            cookies.remove('loginUserCode');
            cookies.remove('userName');

        } else {

            if (typeof LoginUserCode !== 'string') {
                LoginUserCode = String(LoginUserCode);
            }
            const data = { Token, LoginUserCode, ...FilterData };
            post(`${API_SERVER}/api/Dashboard/GetDashboardChart`, { ...data }, (res) => {
              
                if (res.status === "SUCCESS") {
                    setBoardData(res);
                }
                else {
                    throw new Error('Error fetching data from API');
                }
            })

        };
    }
   
    useEffect(() => {
        getChartAPI();
    }, []);
    return (
        <>

            <main id="main" className="main" style={open ? {} : { marginLeft: "0" }}>
                
                <div className="form-box mb-3">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="heading-box"><div className="heading"><h6 className="m-0 font-weight-bold text-primary">Dashboard</h6></div></div>

                            <div className="dash-box">
                                <div className="row align-items-end">                                    
                                    <div className="col-lg-3 col-md-4 col-sm-6">
                                        <label className="form-label">From Date</label>
                                        <div className="fields">
                                            <DatePicker selected={ReverseFormatDate(FilterData.DateFrom) || null}
                                                id='txtDateFrom'
                                                className="form-control"
                                                placeholderText='From Date'
                                                dateFormat={'dd-MMM-yyyy'}
                                                autoComplete='off'
                                                onChange={(date) => {
                                                    setFilterData({ ...FilterData, DateFrom: formatDate(date) })
                                                }}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        setFocus('txtCollectedDateTo')
                                                    };
                                                }}
                                                maxDate={new Date()}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-4 col-sm-6">
                                        <label className="form-label">To Date</label>
                                        <div className="fields">
                                            <DatePicker selected={ReverseFormatDate(FilterData.DateTo) || null}
                                                id='txtDateTo'
                                                className="form-control"
                                                placeholderText='To Date'
                                                dateFormat={'dd-MMM-yyyy'}
                                                autoComplete='off'
                                                onChange={(date) => {
                                                    setFilterData({ ...FilterData, DateTo: formatDate(date) })
                                                }}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        setFocus('btnSearch')
                                                    };
                                                }}
                                                maxDate={new Date()}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-3">
                                        <div className="lms-new-button dash-lms-new-button">
                                            <button className="button save-btn" id='btnSearch' onClick={getChartAPI}>
                                                <i className="bi bi-search" /> Search
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        

                     

                      
                            
                    </div>
                </div>
                <div className="row">
                    <div className="col-xl-6 col-lg-6">
                        <div className="card mb-3">
                            <h6 className="m-0 fw-bold pt-2 text-center">Top Customers</h6>
                            <div className="card-body">
                                <div className="chart-area">
                                    <Bar data={value}/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-6 col-lg-6">
                        <div className="card mb-3">
                            <h6 className="m-0 fw-bold pt-2 text-center">Top Items</h6>
                            <div className="card-body">
                                <div className="chart-area">
                                    <Bar data={value2}  />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="col-xl-12 col-lg-12">
                    <div className="card mb-12">
                        <h6 className="m-0 fw-bold pt-2  text-center">Days Wise Shipments Status</h6>
                        <div className="card-body">
                            <div className="chart-area" >
                                <Bar data={value3} />
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </>
    );
};

export default Dashboard;
